"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = exports.getUrlParams = exports.convertQueryToString = void 0;
function convertQueryToString(query) {
    const handleVal = (key, val) => {
        let str = '';
        // 严格模式下 空字符串检查
        if (val === '') {
            return '';
        }
        const finalKey = key === '' ? '' : `${key}=`;
        const finalVal = val;
        str = `${finalKey}${finalVal}&`;
        return str;
    };
    let str = '';
    Object.keys(query).forEach((objKey) => {
        str += handleVal(objKey, query[objKey]);
    });
    return str.substring(0, Math.max(0, str.length - 1));
}
exports.convertQueryToString = convertQueryToString;
function getUrlParams(url = location.href) {
    const [, queryString = ''] = url.split('?');
    const params = {};
    if (queryString) {
        queryString.split('&').forEach((kvPart) => {
            const [key, value] = kvPart.split('=');
            if (key) {
                params[key] = value;
            }
        });
    }
    return params;
}
exports.getUrlParams = getUrlParams;
const throttle = (method, duration) => {
    let timer = 0;
    let args;
    let begin = Date.now();
    const later = function () {
        const current = Date.now();
        if (duration && current - begin >= duration) {
            method(...args);
            begin = 0;
            clearTimeout(timer);
            timer = 0;
            args = [];
        }
        else {
            clearTimeout(timer);
            timer = window.setTimeout(later, duration - (current - begin));
        }
    };
    return function (...rest) {
        var _a;
        args = rest;
        if (!timer) {
            begin = Date.now();
            timer = window.setTimeout(later, duration);
        }
        // 补充：增加参数清除timeout
        if (((_a = args[args.length - 1]) === null || _a === void 0 ? void 0 : _a.clearTimeout) === true) {
            clearTimeout(timer);
        }
    };
};
exports.throttle = throttle;
